import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

export const StyledAlternativePricesArea = styled.div`
  background-color: ${props => props.theme.colors.base100};

  padding: 0.75rem;
  padding-top: 0;

  > div {
    box-shadow: rgb(230 232 234) 0px 0px 0px 1px;
  }
`;

export const StyledInfoRow = styled.div`
  background-color: ${props => props.theme.colors.base100};
`;

export const StyledExpandButtonWrapper = styled.div<{ $expanded: boolean }>(
  props => css`
    display: flex;
    align-items: stretch;
    justify-content: center;
    width: 40px;

    border-right: 1px solid ${props.theme.colors.staticBase200};
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;

    transition: background-color ${layout.animations.buttonTransition};
    background-color: transparent;

    &:hover {
      background-color: ${props.theme.colors.base100};
    }

    ${props.$expanded &&
    css`
      border-bottom-left-radius: 0;
    `}
  `
);
